<template>
  <nav class="w-full">
    <ul class="h-full w-full px-3 pb-6 pt-3">
      <li v-for="(item, index) in menus" :key="hash(item)" class="mb-2 py-2">
        <TheNuxtLink
          v-if="item.type === 1 && item.link"
          :to="`/${locale}/marketplace${item.link?.url}`"
          :title="item.name"
          class="block w-full items-center justify-between text-base font-bold text-black/70 hover:text-blue-400"
        >
          {{ item.name }}
        </TheNuxtLink>
        <button
          v-if="item.type === 2"
          :title="item.name"
          class="flex w-full items-center justify-between text-left text-base font-bold text-black/70 hover:text-blue-400"
          @click="handleClick(index)"
        >
          <span class="flex-1">{{ item.name }}</span>
          <IconCaret
            direction="right"
            class="block h-6 w-6 basis-6 text-gray-400"
          />
        </button>
      </li>
      <li v-if="isShowLocaleButton" class="mb-2 py-2">
        <button
          class="flex w-full items-center justify-between text-base font-bold text-blue-400"
          :title="localeButtonText"
          @click="currentMobileMenu = 'locale'"
        >
          <div class="flex flex-1 items-center">
            <IconLang class="mr-2 block h-6 w-6 basis-6 text-blue-400" />
            <span class="line-clamp-1 flex-1">{{ localeButtonText }}</span>
          </div>
          <IconCaret
            direction="right"
            class="block h-6 w-6 basis-6 text-blue-400"
          />
        </button>
      </li>
      <li class="mb-2 py-2">
        <TheButton
          id="tracking_contactUs"
          type="outline"
          :to="`/${locale}/marketplace/help/contact-us`"
          :title="$t('header.contact-us')"
          class="w-full"
        >
          <span class="text-sm">{{ $t('header.contact-us') }}</span>
        </TheButton>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import { EnumCNMenuIndex } from '@/stores/menuStore';

  const { locale } = useI18n();
  const menuStore = useMenuStore();
  const { menus, currentMobileMenu } = storeToRefs(menuStore);
  const {
    currentRegion,
    provideLocaleName,
    provideRegionName,
    isShowLocaleButton,
  } = useLanguage();

  const localeButtonText = computed((): string => {
    const regionName = provideRegionName(currentRegion.value || '');
    const localeName = provideLocaleName(locale.value);
    return `${regionName} (${localeName})`;
  });

  const handleClick = (index: number): void => {
    switch (index) {
      case EnumCNMenuIndex.SOLUTIONS:
      case EnumCNMenuIndex.PRODUCTS:
      case EnumCNMenuIndex.RESOURCES:
        currentMobileMenu.value = menus.value[index].name;
        break;
      default:
        currentMobileMenu.value = null;
        break;
    }
  };
</script>
